import React from 'react'

function Loading({ transparent = false }) {
    return (
        <div className={`loader-parent ${transparent ? 'loader-child' : ''}`}>

            <div className="loader">
                <div className="one"></div>
                <div className="two"></div>
            </div>
        </div>
    )
}

export default Loading